export default "__VITE_ASSET__I17PQL7O__"